import { Checkbox } from "antd";
import type { ListFilterControls } from "./ListPage";

interface FilterToggleProps {
  /** The URL param this owns. Present as "true", absent otherwise — never "false". */
  name: string;
  label: string;
  controls: Pick<ListFilterControls, "value" | "set">;
}

/**
 * A yes/no filter in a ListPage's filter bar. Every dashboard tile that counts something a
 * status cannot express (open, overdue, awaiting submission) links here with its param
 * set, so the toggle is what makes the applied filter visible — and clearable — once the
 * user arrives.
 */
export function FilterToggle({ name, label, controls }: FilterToggleProps) {
  return (
    <Checkbox
      className="glut-filter-toggle"
      checked={controls.value(name) === "true"}
      // Cleared to absent rather than "false": an unchecked box is not a filter.
      onChange={(e) => controls.set(name, e.target.checked ? "true" : null)}
    >
      {label}
    </Checkbox>
  );
}
